import React from "react";

import { CircleIcon, CircleIconColorEnum } from "@/components/common/circleIcon";
import { IconTypeEnum } from "@/components/common/icon";
import "./styles.scss";

const ErrorBoundaryBlock = () =>
  (
    <div className="error-block">
      <CircleIcon type={IconTypeEnum.Exclamation} color={CircleIconColorEnum.Red} />
      <span className="error-block__title">Упс! Что-то пошло не так</span>
      <span className="error-block__description">Пожалуйста, обновите страницу — и&nbsp;всё заработает.</span>
    </div>
  );

export default ErrorBoundaryBlock;
